const routes = [
    {
        path: "/student/course/agreements",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "courseagreement_index"
        }
    },
    {
        path: "/student/course/agreement/:id",
        component: () => import("../pages/ApplicationDetails.vue"),
        meta: {
            isAuthenticated: true,
            permission: "courseagreement_show"
        }
    }
]

export default routes;
